import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PaginationParams, SortingParams } from "@src/types/httpApi";

export interface ILibraryFilterForm {
  title: string;
  artist: string;
  album: string;
  label: string;
  bpm: number;
  key: string;
  durationInMinutes: number;

  includedTags: { documentId: string }[];
  excludedTags: { documentId: string }[];
  includedMoods: { documentId: string }[];
  excludedMoods: { documentId: string }[];
  isTopLikedThisWeek?: boolean;
  missingYoutube?: boolean;
  missingSpotify?: boolean;
  missingApple?: boolean;
  missingShazam?: boolean;
  createdDateRange?: {
    startDate?: string;
    endDate?: string;
  };
  scheduleDateRange?: {
    startDate?: string;
    endDate?: string;
  };
}
export interface ILibraryFilters extends ILibraryFilterForm {
  searchText: string;
  pagination: PaginationParams;
}

interface PlaylistState {
  filters: ILibraryFilters;
  sort: {
    field: string;
    direction: "asc" | "desc";
  };
  deleteTrackFromLibrary: {
    status: "idle" | "loading" | "succeeded" | "failed";
    loading: boolean;
    error: string | null;
  };
}

const initialState: PlaylistState = {
  filters: {
    searchText: "",
    title: "",
    artist: "",
    album: "",
    label: "",
    bpm: 0,
    key: "",
    includedTags: [],
    excludedTags: [],
    includedMoods: [],
    excludedMoods: [],
    durationInMinutes: 0,
    isTopLikedThisWeek: false,
    missingYoutube: false,
    missingSpotify: false,
    missingApple: false,
    missingShazam: false,
    createdDateRange: undefined,
    scheduleDateRange: undefined,
    pagination: {
      page: 1,
      pageSize: 50,
    },
  },
  deleteTrackFromLibrary: {
    status: "idle",
    loading: false,
    error: null,
  },
  sort: {
    field: "updatedAt",
    direction: "desc",
  },
};

const librarySlice = createSlice({
  name: "library",
  initialState,
  reducers: {
    setLibraryFilters(state, action: PayloadAction<Partial<ILibraryFilters>>) {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    resetFilters(state) {
      state.filters = {
        ...initialState.filters,
      };
    },
    setSort(state, action: PayloadAction<SortingParams>) {
      state.sort = action.payload;
    },
    resetSort(state) {
      state.sort = initialState.sort;
    },
    setDeleteTrackFromLibraryState(
      state,
      action: PayloadAction<PlaylistState["deleteTrackFromLibrary"]>
    ) {
      state.deleteTrackFromLibrary = {
        ...action.payload,
        ...action.payload,
      };
    },
  },
});

export const {
  setDeleteTrackFromLibraryState,
  setLibraryFilters,
  resetFilters,
  setSort,
  resetSort,
} = librarySlice.actions;

export default librarySlice.reducer;
